import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const sectionRules = ({
  theme,
  flexGrow,
  fullWidth,
  margin,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  readableLineHeight,
  readableWidth,
}) => ({
  ':empty': {
    display: 'none',
  },
  extend: [
    {
      condition: flexGrow,
      style: {
        flexGrow: 1,
      },
    },
    {
      condition: fullWidth,
      style: {
        width: '100%',
      },
    },
    {
      condition: readableLineHeight,
      style: {
        lineHeight: '1.15em',
      },
    },
    {
      condition: readableWidth,
      style: {
        maxWidth: '31em',
      },
    },
    {
      condition: margin,
      style: {
        marginBottom: theme.margin[margin] || margin,
        marginTop: theme.margin[margin] || margin,
      },
    },
    {
      condition: (!margin && !marginBottom && !marginLeft && !marginRight && !marginTop),
      style: {
        marginBottom: theme.margin.medium,
        marginTop: theme.margin.medium,
      },
    },
    {
      condition: marginBottom,
      style: {
        marginBottom: theme.margin[marginBottom],
      },
    },
    {
      condition: marginLeft,
      style: {
        marginLeft: theme.margin[marginLeft],
      },
    },
    {
      condition: marginRight,
      style: {
        marginRight: theme.margin[marginRight],
      },
    },
    {
      condition: marginTop,
      style: {
        marginTop: theme.margin[marginTop],
      },
    },
  ],
});

export const Section = (props) => {
  const {
    flexGrow,
    fullWidth,
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    readableWidth,
    readableLineHeight,
    children,
    className,
    ...otherProps
  } = props;
  const { css } = useFela({
    flexGrow,
    fullWidth,
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    readableWidth,
    readableLineHeight,
  });

  return (
    <div className={`${className ? `${className} ` : ''}${css(sectionRules)}`} {...otherProps}>
      {children}
    </div>
  );
};

Section.propTypes = {
  flexGrow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  margin: PropTypes.string,
  marginBottom: PropTypes.string,
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string,
  marginTop: PropTypes.string,
  className: PropTypes.string,
  readableWidth: PropTypes.bool,
  readableLineHeight: PropTypes.bool,
  children: PropTypes.node,
};

export default React.memo(Section);
